import client from './apiConnector';
import { EventBus } from '@/eventBus.js';
import { TEST_ESTABLISHMENTS, TEST_ESTABLISHMENT } from '../../tests/mocks/establishments.js';
import { TEST_METRICS } from '../../tests/mocks/facets.js';

const mockMode = false;

export default {
  async get({ search = null, selections = [], page = 0, excludeId = null } = {}) {
    try {
      if (mockMode) {
        await new Promise(resolve => setTimeout(resolve, 500));
        return { elements: TEST_ESTABLISHMENTS, stats: { ...TEST_METRICS, total: 3 } };
      }
      const response = await client().post(`/playlist/groups/${page ? 'scroll' : 'initial'}`, {
        ...(page ? { start: page * 20 } : {
            metrics: [
              { type: 'total' },
              { type: 'ts_groups' },
              { type: 'epcis' },
              { type: 'cities' },
            ],
          }
        ),
        ...(search && search.length ? {
            sorts: [
              {
                type: 'group_search',
                query: search,
              },
            ],
          } : {}
        ),
        selections,
        size: 20,
        properties: [
          { type: 'cities' },
          { type: 'group_info' },
          { type: 'coordinates' },
        ],
      });
      return { elements: response.data.elements.filter(it => it.id !== excludeId), stats: response.data.stats };
    } catch (e) {
      if (e.response.status === 401) {
        EventBus.$emit('unauthorized');
      } else {
        EventBus.$emit('apiError', { service: 'establishments', method: 'get', status: 500});
        return [];
      }
    }
  },
  async search({ search = null, page = 0 } = {}) {
    try {
      const response = await client().post(`/playlist/groups/search/fr/${search}`, {
        // start: page * 20,
        // size: 20,
        // properties: [
        //   { type: 'thumbnails' },
        //   { type: 'cities' },
        //   { type: 'group_info' },
        // ],
      });
      return response.data;
    } catch (e) {
      throw e;
      EventBus.$emit('apiError', { service: 'establishments', method: 'get', status: 500});
      return [];
    }
  },
  async getById(establishmentId) {
    try {
      if (mockMode) {
        await new Promise(resolve => setTimeout(resolve, 500));
        return TEST_ESTABLISHMENT;
      }
      const response = await client().post(`/playlist/groups/${establishmentId}`, {});
      return response.data;
    } catch (e) {
      if (e.response.status === 401) {
        EventBus.$emit('unauthorized');
      } else {
        EventBus.$emit('apiError', { service: 'establishments', method: 'getById', status: 500});
      }
      return null;
    }
  },
  async getPotentialByEstablishmentId(establishmentId) {
    try {
      if (mockMode) {
        await new Promise(resolve => setTimeout(resolve, 500));
        return TEST_ESTABLISHMENTS;
      }
      const response = await client().post(`/playlist/groups/${establishmentId}/potentials`, {
        properties: [
          { type: 'group_info' },
          { type: 'coordinates' },
          { type: 'thumbnails' },
        ]
      });
      return response.data.elements;
    } catch (e) {
      EventBus.$emit('apiError', { service: 'establishments', method: 'getPotentialByEstablishmentId', status: 500});
      return [];
    }
  },
  async rename(establishmentId, oldEstablishment, newName) {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      const NEW = TEST_ESTABLISHMENT;
      NEW._name = newName;
    } catch (e) {
      EventBus.$emit('apiError', { service: 'establishments', method: 'rename', status: 500});
      return null;
    }
  },
  async merge(to, from) {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      return true;
    } catch (e) {
      EventBus.$emit('apiError', { service: 'establishments', method: 'merge', status: 500});
      return false;
    }
  },
  async create({ name, sheetIds }) {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      return true;
    } catch (e) {
      EventBus.$emit('apiError', { service: 'establishments', method: 'create', status: 500});
      return false;
    }
  },
  async moveSheetsToEstablishment({ establishmentId, sheetIds }) {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      return true;
    } catch (e) {
      EventBus.$emit('apiError', { service: 'establishments', method: 'moveSheetsToEstablishment', status: 500});
      return false;
    }
  },
};